import app from '../main'
import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { canonicalizeAppPath } from '@/util/categoryRoute'

// 注册路由
function autoloadModuleRoutes() {
  const routes = []
  const moduleContext = require.context('./modules', false, /\.js$/)
  register(routes, moduleContext)
  return routes
}

// 绑定路由
function register(routes, moduleContext) {
  moduleContext.keys().forEach((key) => {
    const module = moduleContext(key)
    routes.push(module.default || module) // 添加了 || module
  })
}

// 获取所有模块路由
function getAllRoutes() {
  const allRoutes = autoloadModuleRoutes()
  // console.log('allRoutes', allRoutes)
  const mergedRoutes = []
  const catchAllRoutes = []
  Object.values(allRoutes).forEach((router) => {
    router.forEach((route) => {
      if (route.path === '/:pathMatch(.*)' || route.path === '/:pathMatch(.*)*') {
        catchAllRoutes.push(route)
      } else {
        mergedRoutes.push(route)
      }
    })
  })
  return [...mergedRoutes, ...catchAllRoutes]
}

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes: getAllRoutes(),
  scrollBehavior(to, from, savedPosition) {
    //页面刷新回到浏览器顶部
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  const canonicalPath = canonicalizeAppPath(to.path)
  if (to.path !== canonicalPath) {
    next({ path: canonicalPath, query: to.query, hash: to.hash, replace: true })
    return
  }

  if (app && app.$t) {
    const title = to.name || ''
    document.title = app.$t(title)
  }
  next()
})

// SPA page_view: skip first route (initial gtag config already covers first paint).
let isFirstGaRoute = true
router.afterEach((to) => {
  if (isFirstGaRoute) {
    isFirstGaRoute = false
    return
  }
  const pagePath = to.meta.pageAlias || to.fullPath
  const pageTitle = to.meta.enName || document.title || to.name || 'Unknown Page'
  const track = typeof trackGA !== 'undefined' ? trackGA : window.trackGA
  if (track && typeof track.pageView === 'function') {
    track.pageView(pagePath, pageTitle, { note: 'spa route change' })
  }
})

export default router
